module.exports = __webpack_public_path__ + "static/testemonial1-3dfabb05b675d79cab4364ba2d807543.png";